"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogout = void 0;
var _userLogoutRequest = require("@ori-events/user-logout-request");
var _clearAllSessionStorageKeys = require("../utils/clearAllSessionStorageKeys");
function showLogoutModal() {
  (0, _clearAllSessionStorageKeys.clearAllSessionStorageKeys)();
  const userLogoutRequestEvent = new CustomEvent(_userLogoutRequest.UserLogoutRequestEvent);
  window.dispatchEvent(userLogoutRequestEvent);
}

/** Hook that exposes function that, when called, shows user logout modal */
const useLogout = () => showLogoutModal;
exports.useLogout = useLogout;